import { useEffect, useState } from "react";
import { fornecedorService } from "../../../../pages/fornecedores/service/fornecedor.service";
import { SelectField } from "../../ui";

interface SelectFornecedoresProps {
  value: string;
  onChange: (id: string, name?: string) => void;
  required?: boolean;
  disabled?: boolean;
}

interface FornecedorOption {
  id: string;
  name?: string;
  corporateName?: string;
  fullName?: string;
}

export function SelectFornecedores({
  value,
  onChange,
  required = false,
  disabled = false,
}: SelectFornecedoresProps) {
  const [fornecedores, setFornecedores] = useState<FornecedorOption[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fornecedorService.select();
      setFornecedores(data);
    };
    fetchData();
  }, []);

  return (
    <SelectField
      label="Selecione um Fornecedor"
      value={value || ""}
      onChange={(e) => {
        const fornecedorSelecionado = fornecedores.find(
          (o) => o.id === e.target.value
        );
        const nome =
          fornecedorSelecionado?.name ||
          fornecedorSelecionado?.corporateName ||
          fornecedorSelecionado?.fullName ||
          "";
        onChange(e.target.value, nome);
      }}
      required={required}
      disabled={disabled}
    >
      <option value="" />
      {fornecedores.map((fornecedor) => (
        <option key={fornecedor.id} value={fornecedor.id}>
          {fornecedor.name || fornecedor.corporateName || fornecedor.fullName}
        </option>
      ))}
    </SelectField>
  );
}
